/**
 * StatutDuMessage — où en est un message qu'on a envoyé : en attente (l'horloge), envoyé (une
 * coche), lu (deux coches, en vert), échec (en rouge), supprimé (la corbeille). Dans le coin
 * d'une bulle sortante, et devant l'aperçu d'une ligne de la liste quand le dernier message est
 * le nôtre. Le libellé (déjà traduit) est dit au lecteur d'écran et au survol.
 *
 *   <StatutDuMessage statut="lu" />
 *   <StatutDuMessage statut="echec" libelle="Not sent" />
 */
import { Clock, AlertCircle, Trash2 } from "../icons";
import { cn } from "../utils";
import "./conversation.css";

export type StatutMessage = "en_attente" | "envoye" | "lu" | "echec" | "supprime";

export const LIBELLES_STATUT: Record<StatutMessage, string> = {
  en_attente: "Envoi en cours…",
  envoye: "Envoyé",
  lu: "Lu",
  echec: "Échec de l'envoi",
  supprime: "Supprimé",
};

export interface StatutDuMessageProps {
  statut: StatutMessage;
  /** Ce qu'on en dit, déjà traduit. Défaut : `LIBELLES_STATUT`. */
  libelle?: string;
  className?: string;
}

function Coche() {
  return (
    <svg viewBox="0 0 16 16" aria-hidden fill="none" stroke="currentColor" strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round">
      <path d="M2.8 8.6l3.1 3.1 7.3-7.6" />
    </svg>
  );
}

function DeuxCoches() {
  return (
    <svg viewBox="0 0 20 16" aria-hidden fill="none" stroke="currentColor" strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round">
      <path d="M1.6 8.6l3.1 3.1 7.3-7.6" />
      <path d="M9.6 11.1l0.6 0.6 7.3-7.6" />
    </svg>
  );
}

export function StatutDuMessage({ statut, libelle, className }: StatutDuMessageProps) {
  const dit = libelle ?? LIBELLES_STATUT[statut];
  return (
    <span className={cn("cv-statut", className)} data-statut={statut} role="img" aria-label={dit} title={dit}>
      {statut === "en_attente" ? (
        <Clock aria-hidden />
      ) : statut === "envoye" ? (
        <Coche />
      ) : statut === "lu" ? (
        <DeuxCoches />
      ) : statut === "echec" ? (
        <AlertCircle aria-hidden />
      ) : (
        <Trash2 aria-hidden />
      )}
    </span>
  );
}
